import { render, staticRenderFns } from "./RestoraniGuest.vue?vue&type=template&id=287230b1&scoped=true"
import script from "./RestoraniGuest.vue?vue&type=script&lang=js"
export * from "./RestoraniGuest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287230b1",
  null
  
)

export default component.exports